/*!
 * devextreme-vue
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigurationOptions = exports.setVModel = exports.getVModelValue = exports.getNodeTypeOfComponent = exports.getNodeOptions = exports.saveComponentInstance = exports.usedConfigurationProps = exports.getComponentProps = exports.mount = exports.defaultSlots = exports.declaredTemplates = exports.configurationTemplate = exports.configurationDefaultTemplate = exports.configurationChildren = exports.getNormalizedProps = exports.getComponentInstance = exports.getComponentInfo = exports.getChildren = exports.VMODEL_NAME = void 0;
var vue_1 = require("vue");
var helpers_1 = require("./helpers");
var children_processing_1 = require("./children-processing");
exports.VMODEL_NAME = "modelValue";
function getChildren(component) {
    if (!hasChildren(component) || !component.$_config) {
        return [];
    }
    var children = component.$.subTree && component.$.subTree.children;
    if (!Array.isArray(children)) {
        return [];
    }
    return children.filter(function (child) {
        if (!children_processing_1.isFragment(child)) {
            return child;
        }
        return;
    });
}
exports.getChildren = getChildren;
function getComponentInfo(component) {
    return getConfigurationOptions(component);
}
exports.getComponentInfo = getComponentInfo;
function getComponentInstance(component) {
    return component.type && component.type.$_componentInstance;
}
exports.getComponentInstance = getComponentInstance;
function getNormalizedProps(props) {
    var result = {};
    for (var propName in props) {
        if (props.hasOwnProperty(propName)) {
            result[helpers_1.camelize(propName)] = props[propName];
        }
    }
    return result;
}
exports.getNormalizedProps = getNormalizedProps;
function configurationChildren(component) {
    if (!component.children || !component.children.default) {
        return [];
    }
    return findConfigurationComponents(component.children.default());
}
exports.configurationChildren = configurationChildren;
function configurationDefaultTemplate(node) {
    if (!node.children || node.children === "object" || !node.children.default) {
        return;
    }
    return hasInlineTemplate(node.children.default()) ? node.children.default : undefined;
}
exports.configurationDefaultTemplate = configurationDefaultTemplate;
function configurationTemplate(node) {
    return configurationDefaultTemplate(node);
}
exports.configurationTemplate = configurationTemplate;
function declaredTemplates(component) {
    return component.$slots;
}
exports.declaredTemplates = declaredTemplates;
function defaultSlots(component) {
    var templates = declaredTemplates(component);
    if (!templates.default) {
        return [];
    }
    return templates.default();
}
exports.defaultSlots = defaultSlots;
function mount(options, parent, el) {
    var template = vue_1.createApp(options);
    template.provide("eventBus", parent.eventBus);
    setAppContext(template, parent);
    return template.mount(el);
}
exports.mount = mount;
function getComponentProps(component) {
    var props = component.$.vnode.props || {};
    return getNormalizedProps(props);
}
exports.getComponentProps = getComponentProps;
function usedConfigurationProps(node) {
    return node.props;
}
exports.usedConfigurationProps = usedConfigurationProps;
function saveComponentInstance(component) {
    var nodeOptions = getNodeTypeOfComponent(component);
    if (nodeOptions) {
        nodeOptions.$_componentInstance = component;
    }
}
exports.saveComponentInstance = saveComponentInstance;
function getNodeOptions(component) {
    if (component.$) {
        return component.$.vnode;
    }
    return component;
}
exports.getNodeOptions = getNodeOptions;
function getNodeTypeOfComponent(component) {
    return component.$.vnode.type;
}
exports.getNodeTypeOfComponent = getNodeTypeOfComponent;
function getVModelValue(options) {
    return options[exports.VMODEL_NAME];
}
exports.getVModelValue = getVModelValue;
function setVModel(config) {
    var _a;
    var eventName = "update:" + exports.VMODEL_NAME;
    config.model.prop = exports.VMODEL_NAME;
    config.model.event = eventName;
    config.props.modelValue = {};
    config.emits = __assign(__assign({}, config.emits), (_a = {}, _a["" + eventName] = null, _a));
}
exports.setVModel = setVModel;
function setCustomPluginsData(appContext, parentAppContext) {
    for (var prop in parentAppContext) {
        if (!appContext.hasOwnProperty(prop) && parentAppContext.hasOwnProperty(prop)) {
            appContext[prop] = parentAppContext[prop];
        }
    }
}
function setAppContext(template, parent) {
    template._context.components = Object.assign(parent.$.appContext.components, template._context.components);
    Object.setPrototypeOf(template._context.provides, Object.getPrototypeOf(parent.$.provides));
    Object.assign(template._context.provides, parent.$.appContext.provides);
    template._context.config = parent.$.appContext.config;
    template._context.directives = parent.$.appContext.directives;
    template._context.mixins = parent.$.appContext.mixins;
    setCustomPluginsData(template._context.app, parent.$.appContext.app);
}
function findConfigurationComponents(children) {
    return children.filter(function (child) {
        if (children_processing_1.isFragment(child)) {
            return findConfigurationComponents(child.children || []);
        }
        var childType = child.type;
        if (childType && typeof childType === "object" && childType.$_optionName) {
            delete child.$_config;
            delete child.$_innerChanges;
            return child;
        }
        return;
    });
}
function hasInlineTemplate(children) {
    var hasTemplate = false;
    children.forEach(function (child) {
        if (!isConfiguration(child) && !children_processing_1.isFragment(child) && child.children !== "v-if") {
            hasTemplate = true;
        }
    });
    return hasTemplate;
}
function isConfiguration(child) {
    return child.type && typeof child.type === "object" && child.type.$_optionName;
}
function getConfigurationOptions(node) {
    return node.type;
}
exports.getConfigurationOptions = getConfigurationOptions;
function hasChildren(component) {
    return component.$.vnode && component.$.vnode.children && component.$.vnode.children.default;
}
